import config from "@core/config";
import { UserInfoDtoWithToken } from "@core/types";
import { type IConfig } from "unleash-proxy-client";

export const getUnleashConfig = (userInfo: UserInfoDtoWithToken): IConfig => ({
  url: config.UNLEASH_URL,
  clientKey: config.UNLEASH_CLIENT_KEY,
  refreshInterval: 60,
  appName: config.UNLEASH_CLIENT_NAME,
  fetch: (url: string | URL | Request, options?: RequestInit) => {
    if (!navigator.onLine) {
      return new Response(null, {
        status: 304,
      });
    }
    return fetch(url, options);
  },
  context: {
    userId: String(userInfo?.id),
    properties: {
      ccauRoleName: userInfo?.currentRole?.toString() ?? "",
    },
  },
});
